import { render, staticRenderFns } from "./resourceSheetReport.vue?vue&type=template&id=6bc0f384&scoped=true&"
import script from "./resourceSheetReport.vue?vue&type=script&lang=js&"
export * from "./resourceSheetReport.vue?vue&type=script&lang=js&"
import style0 from "./resourceSheetReport.vue?vue&type=style&index=0&id=6bc0f384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0f384",
  null
  
)

export default component.exports